import React from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@mui/material";
function Navbar({ link }) {
  useEffect(() => {
    document.title = `${link} to levitra`;
  }, [link]);
  return (
    <div className="bg-transparent flex px-6 py-3 justify-between w-full">
      <div className="flex flex-col">
        <h1 className="border-b-2 fon border-solid border-[#152A74] pb-1 text-[#152A74] font-[800] text-3xl">
          Levitra
        </h1>
        <span className="text-sm text-[#152A74] font-semibold">
          Health Ensures
        </span>
      </div>
      <div className="flex items-center gap-5">
        <Link
          to={`/registry/${link === "Login" ? "signup" : "login"}`}
          className="font-bold text-xl"
        >
          {link === "Login" ? "Signup" : "Login"}
        </Link>
        <Button
          style={{
            background: "#152A74",
            color: "white",
            borderRadius: 9999,
            fontWeight: 600,
            padding: "10px 20px",
          }}
          className="rounded-full font-semibold px-8 py-3 text-white"
        >
          Request Demo
        </Button>
      </div>
    </div>
  );
}

export default Navbar;
